import { css } from 'emotion'

export const ReadAllButtonStyles = css`
  padding: 8px
`
